<div class="footer-background" *ngIf="cmsContentService.cmsContent$ | async as cmsContentConfig">
  <img class="footer-logo" src="../../../../../../assets/image/white-Logo.svg">
  <div class="copyright">{{cmsContentConfig['text_content']['all-pages-footer-copyright-label']}} © {{currentYear}} {{cmsContentConfig['text_content']['all-pages-footer-copyright-text']}}</div>
  <div class="terms-condition"><a routerLink="/terms-and-conditions">{{cmsContentConfig['text_content']['all-pages-footer-t-and-c-label']}}</a></div>
</div>
